<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">关于我们</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div>
                <div class="company">
                    <img src="../../assets/images/systemIcon.png" alt="">
                    <span>上海卡逸客互联网科技有限公司</span>
                    <span>V{{ version }}</span>
                </div>
                <div class="serverList">
                    <ul>
                        <li class="item">
                            <img src="../../assets/images/telphone.png" alt="">
                            <span>客服热线</span>
                            <span>021-80158000</span>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/tencentQQ.png" alt="">
                            <span>客服QQ</span>
                            <span>876508800</span>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/tencentWechat.png" alt="">
                            <span>客服微信</span>
                            <span>18051809399</span>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/email.png" alt="">
                            <span>联系邮箱</span>
                            <span>public@kayike.com</span>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="itemList">
                <ul>
                    <li class="item1">
                        <img src="../../assets/images/server.png" alt="">
                        <span>服务协议</span>
                        <i class="el-icon-arrow-right Rarrow"></i>
                    </li>
                    <li class="item1">
                        <img src="../../assets/images/secret.png" alt="">
                        <span>隐私政策</span>
                        <i class="el-icon-arrow-right Rarrow"></i>
                    </li>
                </ul>
            </div>
        </div>
        <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
    </div>
</template>
<script>
import { Navbar, TabItem,Switch,Actionsheet } from 'mint-ui';
export default {
  data() {
    return {  
        value1:true, 
        value2:true,
        value3:false,
        value4:false,
        sheetVisible: false,
        actions:[],  
    };
  },
  computed: {},
  components: {},
  methods: {
      handleChange(event){
          console.log(event);
          if(event == true){
            this.sheetVisible = true;
          }else{
            this.sheetVisible = false;
          }
          
      }     
  },
  mounted(){
        this.actions = [{
        name: '关闭后，手机将不再接收到新消息通知。',
      },{
        name: '确认关闭',
      }];
    },           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right{
    float: right;
    color: rgba(0, 0, 0,1);
    margin-top: 0.5rem;
    font-size: 0.55rem;
    margin-right: 0.6rem
}
.company{
    width: 100%;
    height: 4.76rem;
    text-align: center;
    background-color: #fff;
    margin-top: 0.2rem;
    position: relative;
}
.company :nth-child(1){
    width: 1.71rem;
    height: 1.71rem;
    position: absolute;
    top: 1.05rem;
    left: 4.08rem;
}
.company :nth-child(2){
    font-size: 0.47rem;
    line-height: 0.66rem;
    color: rgba(0, 0, 0, 0.7);
    position: absolute;
    top: 3.03rem;
    left: 1.61rem;
}
.company :nth-child(3){
    font-size: 0.1rem;
    line-height: 0.22rem;
    color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 3.82rem;
    left: 3.95rem;
}
.serverList,
.itemList{
    background-color: #fff;
    overflow: hidden;
}
.itemList{
    margin-top: 0.68rem;
}
.item,
.item1{
    height: 1.29rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    margin-left: 0.53rem;
    line-height: 0.61rem;
    position: relative;
}
.item :nth-child(1),
.item1 :nth-child(1){
    width: 0.68rem;
    height: 0.68rem;
    position: absolute;
    top: 0.37rem;
    left: 0;
}
.item :nth-child(2),
.item1 :nth-child(2){
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.9);
    line-height: 0.61rem;
    position: absolute;
    top: 0.39rem;
    left: 1.15rem;
}
.item :nth-child(3){
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
    line-height: 0.61rem;
    position: absolute;
    top: 0.39rem;
    left: 3.84rem;
}
.el-icon-arrow-right{
    position: absolute;
    top: 0rem;
    right: 0rem;
}
</style>




// WEBPACK FOOTER //
// src/components/mine/about.vue